<template>
  <div
    :class="[
      'tw-w-full tw-flex tw-flex-col tw-relative tw-h-full',
      'tw-overflow-auto scrollbar-hide',
    ]"
  >
    <div
      :class="[
        'tw-text-h3-bold-mobile apTablet2:tw-text-h3-bold-desktop',
        'tw-mt-8 tw-mb-[64px]',
      ]"
    >How can we help you?</div>
    <div class="tw-pb-6 tw-text-body-bold-mobile apTablet2:tw-text-body-bold-desktop">
      Please select one:
    </div>
    <div class="tw-grid tw-grid-cols-1 apDesktop:tw-grid-cols-2 tw-gap-4 tw-pb-4">
      <SelectForm
        v-for="option in options"
        :key="option"
        :value="option"
        :selected="selectedOption === option"
        @click="onClick(option)"
      />
    </div>
    <TextForm v-model:data="otherOption" :placeholder="'Others (please specify)'" />
    <div class="apDesktop:tw-mb-[64px] tw-mb-[78px] tw-mt-[76px]">
      <NextButton label="Next" :enable="allowNextButton" @click="emit('clickNext')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { ContactUs } from '../../model/interfaces/ContactUs';
import SelectForm from '../shared/SelectForm.vue';
import TextForm from '../shared/TextForm.vue';
import NextButton from './NextButton.vue';

const props = defineProps < {
  contactUs: ContactUs
} > ();

const emit = defineEmits(['clickNext']);

const selectedOption = ref('');
const otherOption = ref('');


const options = ref([
  'I’d like a cost estimate',
  'I have a confirmed project that I’d like built',
  'I want to enhance my existing system',
  'I need you to maintain my existing system'
]);

function onClick(option: string){
  if (selectedOption.value === option) {
    selectedOption.value = '';
  }else{
    selectedOption.value = option;
  }
}

onMounted(() => {
  if (props.contactUs.contact_purpose !== '') {
    if (options.value.includes(props.contactUs.contact_purpose)) {
      selectedOption.value = props.contactUs.contact_purpose;
    }else{
      otherOption.value = props.contactUs.contact_purpose;
    }
  }
});

const allowNextButton = computed(() => {
  return props.contactUs.isValidContactPurpose();
});

watch(selectedOption, (value) => {
  props.contactUs.contact_purpose = value;
  otherOption.value = '';
}, { deep: true });

watch(otherOption, (value) => {
  props.contactUs.contact_purpose = value;
  if (value === '') return;
  selectedOption.value = '';
}, { deep: true });

</script>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>